export const DASHBOARD_API_URL = `https://dashboard.arcomurray.com/`;

export const COMMUNIFIRE_API_KEY = process.env.COMMUNIFIRE_API_KEY || 'ZGphc2FuaTozMDMzNjI0Ny1mYjdkLTQ2ZDYtYWFkYi01M2EyOWFlZWRiMjY='

const __ON__LOCALHOST__ = window.location.hostname.includes('localhost');
export const API_HOST = __ON__LOCALHOST__
	? 'localhost:8001/'
	: (process.env.REACT_APP_API_HOST || 'admin.roster.arcomurray.com/');
export const HOST = `${API_HOST}`;
export const apiPath = 'api/v1/';
export const API_URL = __ON__LOCALHOST__ ? `http://${HOST}${apiPath}` : `https://${HOST}${apiPath}`;

export const PROCORE_DOMAIN = process.env.REACT_APP_PROCORE_DOMAIN || 'app.procore.com';
export const SFDC_DOMAIN = process.env.REACT_APP_SFDC_DOMAIN || 'arcomurray.lightning.force.com';